import withAuth from "./../../common/helper/auth-component.js";
import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import MUIButton from "../../common/miui-component/mui-button.jsx";
import TransactionCard from "./comparisionCard.js";
import TransactionTable from "./TransactionCompareTable.js";
import BasicTextFields from "../../common/miui-component/mui-textfield.jsx";
import TransactionModal from "../../common/modals/tranactionApproval.js";
import dashboardService from "../../../services/dashboard-service.js";
import { toast } from "react-toastify";
import LoaderOverlay from "../../common/helper/loader.component.js";

const CompareTransaction = () => {
  const [selected, setSelected] = useState(null);
  const [compare, setCompare] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    utr_id: "",
    merchant_code: "",
    order_code: "",
    amount: "",
  });
  const [responseData, setResponseData] = useState([]);
  const [formDataError, setFormDataError] = useState({
    utr_id: null,
    merchant_code: null,
    order_code: null,
    amount: null,
  });
  const [holdModalFieldVal, setholdModalFieldValuseState] = useState({
    utr_id: "",
    merchant_code: "",
    order_code: "",
    amount: "",
    status: "",
    startDate: "",
    updatedDate: "",
  });
  const [modalShow, setModalShow] = useState(false);
  const handleCompare = (name) => {
    setCompare((prev) =>
      prev.includes(name) ? prev : [...prev, name].slice(-6)
    );
  };

  const [hoveredRow, setHoveredRow] = useState(null);

  const products = [
    {
      name: "Product A",
      rating: 4.5,
      reviews: 6,
      depth: 9.53,
      model: "15-dw3365st",
      height: 0.8,
      ram: "8GB",
      color: "Natural silver",
      width: 14.1,
    },
    {
      name: "Product B",
      rating: 4.5,
      reviews: 34,
      depth: 9.2,
      model: "15-eg0165st",
      height: 0.7,
      ram: "12GB",
      color: "Natural Silver Aluminum",
      width: 14.2,
    },
  ];

  const handleChangeField = ({ target: { name, value } }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   dashboardService
  //     .compareTransaction({
  //       utr_id: "123456789013",
  //       order_code: "TXN523951687052824576",
  //       merchant_reference_code: null,
  //       amount: "8978",
  //     })
  //     .then((data) => {
  //       setResponseData(data.data);
  //     })
  //     .catch((err) => {
  //       toast.error(err.response?.data?.error.message || "Invalid requests");
  //       setResponseData([]);
  //       setFormDataError({
  //         utr_id: null,
  //         merchant_code: null,
  //         order_code: null,
  //         amount: null,
  //       });
  //     })
  //     .finally(() => {
  //       console.log("Excuted");
  //     });
  // }, []);

  const validateFieldData = () => {
    let errors = {};
    let isValid = true;
    for (let [key, value] of Object.entries(formData)) {
      if (value == "") {
        if (key == "merchant_code" || key == "order_code") {
          if (formData.merchant_code == "" && formData.order_code == "") {
            errors[key] = true;
            isValid = false;
          }
        } else {
          errors[key] = true;
          isValid = false;
        }
      } else {
        errors[key] = false;
      }
    }
    setFormDataError(errors);
    return isValid;
  };

  const handleFocusFilterField = ({ target: { name, value } }) => {
    setFormDataError((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const handleApplyFilters = () => {
    const isValidField = validateFieldData();
    if (isValidField) {
      setIsLoading(true);
      dashboardService
        .compareTransaction({
          utr_id: formData?.utr_id,
          order_code: formData?.order_code,
          merchant_reference_code: formData?.merchant_code,
          amount: formData?.amount,
        })
        .then((data) => {
          setResponseData(data.data.data);
          setholdModalFieldValuseState({
            utr_id: data?.data?.data?.comparison_data?.[0].utr_id,
            merchant_code:
              data?.data?.data?.comparison_data?.[0].merchant_reference_code,
            order_code: data?.data?.data?.comparison_data?.[0].order_code,
            amount: data?.data?.data?.comparison_data?.[0].amount,
            status: data?.data?.data?.comparison_data?.[0].status,
            startDate: data?.data?.data?.comparison_data?.[0].start_date,
            updatedDate: data?.data?.data?.comparison_data?.[0].updated_on,
          });
        })
        .catch((err) => {
          setResponseData([]);
          toast.error(err.response?.data?.error?.message || "Invalid requests");
          setFormDataError({
            utr_id: null,
            merchant_code: null,
            order_code: null,
            amount: null,
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  return (
    <>
      <LoaderOverlay loading={isLoading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="d-flex justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Support Transaction
          </h4>
        </div>
        <div
          className="container-fluid mb-4"
          style={{
            backgroundColor: "white",
            float: "left",
            borderRadius: "15px",
          }}
        >
          <nav className="flex justify-content-between py-1">
            <div
              className="nav nav-tabs d-flex justify-content-between"
              id="nav-tab"
              role="tablist"
            >
              {/* <MUITextField /> */}
              <button
                className="nav-link tbbtn active text-color-theme"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                style={{ fontSize: "16px" }}
              >
                Transaction
              </button>
              <div className="d-flex align-items-center justify-content-between w-75">
                <div>
                  <BasicTextFields
                    val={formData.utr_id}
                    label="UTR ID*"
                    name="utr_id"
                    handleChange={handleChangeField}
                    isError={formDataError?.utr_id}
                    handleFocus={handleFocusFilterField}
                    inputType={"number"}
                  />
                </div>
                <div
                  style={{
                    background: "#80808073",
                    width: "1px",
                    height: "42px",
                  }}
                ></div>
                <div className="d-flex gap-1">
                  <div className="">
                    <BasicTextFields
                      val={formData.merchant_code}
                      name="merchant_code"
                      label="Merchant Code*"
                      handleChange={handleChangeField}
                      isError={formDataError?.merchant_code}
                      handleFocus={handleFocusFilterField}
                      inputType="text"
                    />
                  </div>{" "}
                  <span className="mx-1 d-flex align-items-center">Or</span>
                  <BasicTextFields
                    val={formData.order_code}
                    name="order_code"
                    label="Order Code*"
                    handleChange={handleChangeField}
                    isError={formDataError?.order_code}
                    handleFocus={handleFocusFilterField}
                    inputType="text"
                  />
                </div>
                <div
                  style={{
                    background: "#80808073",
                    width: "1px",
                    height: "42px",
                  }}
                ></div>
                <div>
                  <BasicTextFields
                    val={formData.amount}
                    name="amount"
                    label="Amount*"
                    handleChange={handleChangeField}
                    isError={formDataError.amount}
                    handleFocus={handleFocusFilterField}
                    inputType="number"
                  />
                </div>
                <div>
                  <MUIButton
                    btnOnClick={handleApplyFilters}
                    btnLabel="Apply"
                    btnStyle={{
                      capitalize: "camelcase",
                      backgroundColor: "#495a69",
                      border: "1px solid #b1adadd9",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "rgb(117 121 124 / 82%)",
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </nav>
          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
          >
            <div
              className="tab-pane fade active show"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <main>
                <div className style={{ paddingBottom: "30px" }}>
                  <div className style={{ backgroundColor: "white" }}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div
                        className="tab-pane fade show active"
                        id="nav-home"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab"
                      >
                        <div
                          className="col-md-12"
                          style={{ textAlign: "right" }}
                        ></div>

                        <div
                          id="examplemgmwallet_wrapper"
                          className="dataTables_wrapper dt-jqueryui no-footer"
                        >
                          {responseData?.comparison_data?.length ? (
                            <div
                              style={{
                                //                           minHeight: "400px",
                                // maxHeight:'auto',
                                height: "auto",
                                overflowY: true ? "auto" : "visible",
                                padding: "0px 20px",
                              }}
                              className="scrapper-table"
                            >
                              <div className="mt-2">
                                <TransactionCard
                                  data={responseData?.comparison_data}
                                />
                              </div>
                              <div className="mt-5">
                                <TransactionTable
                                  data={responseData?.comparison_data}
                                  formData={formData}
                                />
                              </div>

                              <div className="row mt-5 justify-content-between">
                                <div className="col-7">
                                  <div class="mb-3">
                                    <label
                                      for="exampleFormControlTextarea1"
                                      class="form-label h4"
                                    >
                                      Tranaction Info
                                    </label>
                                    <textarea
                                      class="form-control"
                                      id="exampleFormControlTextarea1"
                                      rows="3"
                                      value={responseData?.message}
                                      style={{ borderRadius: "12px" }}
                                    ></textarea>
                                  </div>
                                </div>
                                <div className="col-2 mt-3 d-flex align-items-center">
                                  <MUIButton
                                    isdisabled={
                                      !responseData?.processing_allowed
                                    }
                                    btnOnClick={() => setModalShow(true)}
                                    btnLabel="Review and Submit"
                                    btnStyle={{
                                      capitalize: "camelcase",
                                      backgroundColor: "#495a69",
                                      border: "1px solid #b1adadd9",
                                      color: "white",
                                      "&:hover": {
                                        backgroundColor:
                                          "rgb(117 121 124 / 82%)",
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="d-flex align-items-center w-100"
                              style={{ height: "50vh" }}
                            >
                              <p className="text-center w-100 h4">
                                No data found...
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
        <div>
          <TransactionModal
            show={modalShow}
            data={[]}
            holdModalFieldVal={holdModalFieldVal}
            onHide={() => setModalShow(false)}
            size="lg"
          />
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(CompareTransaction));
